// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "resource/js/components/dashboard" + "-legacy." + "90073d8f" + ".js";
};